import Server from '@/service/server'

export default {
  namespaced: true,
  state: {
    isClientAuthenticated: false,
    isAuthenticatingClient: false,
    isClientAuthenticationFailed: false,

    isUserAuthenticated: false,
    isAuthenticatingUser: false,
    isUserAuthenticationFailed: false,

    clientToken: {},
    userToken: {},
      userProfile: {},
    resetToken:""
    // userSubscriptionStatus: "",
  },
  getters: {
    isClientAuthenticated (state: any) {
      return state.isClientAuthenticated
    },
    isAuthenticatingClient (state: any) {
      return state.isAuthenticatingClient
    },
    isClientAuthenticationFailed (state: any) {
      return state.isClientAuthenticationFailed
    },
    isUserAuthenticated (state: any) {
      return state.isUserAuthenticated
    },
    isAuthenticatingUser (state: any) {
      return state.isAuthenticatingUser
    },
    isUserAuthenticationFailed (state: any) {
      return state.isUserAuthenticationFailed
    },
    token (state: any) {
      if (state.isUserAuthenticated) return state.userToken
      else if (state.isClientAuthenticated) return state.clientToken
      else return {}
    },
    userToken (state: any) {
      return state.userToken
    },
    userProfile (state: any) {
      return state.userProfile
      },
      resetPasswordToken(state: any) {
          return state.resetToken;
      }
    // userSubscriptionStatus(state: any) {
    //  return state.userSubscriptionStatus;
    // }
  },
  actions: {
    init (context: any) {
      let promise = context.dispatch('authenticateClient')

      let userToken = localStorage.getItem('userToken')
      if (userToken) {
        context.commit('userTokenFetchedFromLocal', JSON.parse(userToken))
        context.dispatch('loadUserProfile')
      }

      return promise
    },
    authenticateClient (context: any) {
      context.commit('clientTokenPending')
      let promise = Server.authenticate({ userName: '', password: '' })
      promise.then(
        (response: any) => {
          let result = response.body.result
          context.commit('clientTokenSucceeded', result.tokenInfo)
          context.commit('tenantConfig/tenantInfoReceived', result.tenantInfo, { root: true })
          // TODO: This section must be received from TenantDesign service, but currently stored as a property in TenantInfo
          context.dispatch('tenantDesign/setConfig', JSON.parse(result.tenantInfo.portalConfigurations), { root: true })
        },
        (error: any) => {
          context.commit('clientTokenFailed')
        }
      )
      return promise
    },
    authenticateVasUser (context: any, username: string) {
      context.commit('userTokenPending')
      let promise = Server.authenticateVasUser({ userName: username })
      promise.then(
        (response: any) => {
          let result = response.body.result
          if (result.resultType === 'Success') {
            context.commit('userTokenSucceeded', result)
            context.dispatch('loadUserProfile')
          } else {
            context.commit('userTokenFailed')
          }
        },
        (error: any) => {
          context.commit('userTokenFailed')
        }
      )
      return promise
    },
    // getUserSubscriptionStatus(context: any, username: any) {
    //  var promise = Server.getUserStatus({ userName: username }).then((response:any) => {
    //    context.commit("userSubscriptionStatusLoaded", response.body.result[0]);
    //    return response;
    //  });
    //  return promise;
    // },

    authenticateOrganicUser (context: any, payload: any) {
      context.commit('userTokenPending')
      var userStatePromise = Server.getUserStatus({ userName: payload.username }).then((userStateResponse: any) => {
        var userState = userStateResponse.body.result
        if (userState.length > 0) {
          payload.username = userState[0].userName
        }
        var organicPromise = Server.loginUser(payload).then(
          (oresponse: any) => {
            var oresult = oresponse.body.result
            if (oresult.resultType === 'Success') {
              context.commit('userTokenSucceeded', oresult)
              var promise = Server.getUserState().then(
                (response: any) => {
                  var result = response.body.result
                  if (result.length === 0) {
                    context.commit('userTokenFailed')
                  } else {
                    context.commit('userTokenSucceeded', oresult)
                    context.dispatch('loadUserProfile')
                  }
                },
                (error: any) => {
                  context.commit('userTokenFailed')
                }).catch((error: any) => {
                var star = error
              })
              return oresult
            } else {
              context.commit('userTokenFailed')
            }
            return oresult
          })
        return organicPromise
      },
      (error: any) => {
        context.commit('userTokenFailed')
      }
      )
      return userStatePromise
    },
    loadUserProfile (context: any) {
      let promise = Server.self().then((response: any) => {
        if (response.status == 200) {
          context.commit('userProfileLoaded', response.body.result)
        } else {
          context.commit('userTokenFailed')
        }
      }).catch((response: any) => {
        if (response.status == 401) {
          context.commit('userTokenFailed')
        }
      });
      },
      sendResetToken(context: any, payload: any) {
          let username = JSON.stringify(payload.username);
          var promise = Server.sendResetToken(username).then((response: any) => {
              return response;
          })
          return promise;
      },
      verifyToken(context: any, payload: any) {
          let params = {
              username: payload.username,
              token: payload.token
          }
          const promise = Server.verifyToken(params, params).then((response: any) => {
              if (response.body.result.succeeded === true) {
                  context.commit('userResetPasswordToken', payload.token);
              }
              return response;
          })
          return promise;
      },
      resetPassword(context: any, payload: any) {
          let token = context.state.resetToken;
          let params = {
              resettoken: token,
              username: payload.username,
              password:payload.password
          }
          const promise = Server.resetPassword(params, params).then((resposnse: any) => {
              return resposnse;
          })
          return promise;
      },
      logout(context: any) {
        if ((process as any).browser) {
          let domain = window.location.host.split('/')[0].split('.')
          let cookieDomain = domain[domain.length - 2] + '.' + domain[domain.length - 1]
          context.commit("userLoggedOut",cookieDomain );
       } 
     } 
  },
  mutations: {
    clientTokenPending(state: any, token: any) {
      state.clientToken = token;
      state.isAuthenticatingClient = true;
    },
    clientTokenFailed(state: any) {
      state.isClientAuthenticated = false;
      state.isAuthenticatingClient = false;
      state.isClientAuthenticationFailed = true;
    },
    clientTokenSucceeded(state: any, token: any) {
      state.isAuthenticatingClient = false;
      state.isClientAuthenticated = true;
      state.clientToken = token;
    },
    userTokenFetchedFromLocal(state: any, token: any) {
      state.isUserAuthenticated = true;
      state.userToken = token;
    },
    userTokenPending(state: any) {
      state.isAuthenticatingUser = true;
      state.isUserAuthenticationFailed = false;
    },
    userTokenSucceeded(state: any, token: any) {
      localStorage.setItem('userToken', JSON.stringify(token));
      state.isAuthenticatingUser = false;
      state.isUserAuthenticated = true;
      state.isUserAuthenticationFailed = false;
      state.userToken = token;
    },
    userTokenFailed(state: any) {
      state.isAuthenticatingUser = false;
      state.isUserAuthenticated = false;
      state.isUserAuthenticationFailed = true;
      localStorage.removeItem('userToken');
    },
    userLoggedOut(state: any, domain: any) {
      state.isAuthenticatingUser = false;
      state.isUserAuthenticated = false;
      state.isUserAuthenticationFailed = false;
      state.userToken = '';
      localStorage.removeItem('userToken');
      document.cookie = 'userName="";domain=' + domain + ';path=/'
    },
    userProfileLoaded(state: any, payload: any) {
      state.userProfile = payload;
      },
      userResetPasswordToken(state: any, token: any) {
          state.resetToken = token;
      }
    //userSubscriptionStatusLoaded(state: any, payload: any) {
    //  state.userSubscriptionStatus = payload;
    // }
  }
}
